module.exports = __webpack_public_path__ + "static/lei-seca-c2575e371a235dfb0f08eb918c5d2998.jpg";